(function ($) {
	if ($('.owl-carousel').length > 0) {
		// Run owl carousel
		$('.owl-carousel--multiple').owlCarousel({
			loop: false,
			responsiveClass: true,
			dots: false,
			nav: true,
			responsive: {
				0: {
					items: 1,
				},
				381: {
					items: 2,
					autoWidth: true,
				},
				1281: {
					items: 4,
					autoWidth: true,
				},
			},
		});

		$('.owl-carousel--single').owlCarousel({
			loop: false,
			responsiveClass: true,
			dots: false,
			nav: true,
			singleItem: true,
			responsive: {
				0: {
					items: 1,
				},
				381: {
					items: 1,
					autoWidth: true,
				},
				1281: {
					items: 1,
					autoWidth: true,
				},
			},
		});
	}
})(window.jQuery);
